import { useState, useEffect } from "react";
import ClientHeader from "../../../common/ClientHeader";
import ProtectedPage from "../../../common/ProtectedPage";
import Sidebar from "../../../common/Sidebar";
import { CategoriesQueriesClient } from "../../../../requests/queries/CategoriesQueries";
import "./ShippingPolicyStyles.css";

export default function ShippingPolicy({ currentCommand, setCurrentCommand }) {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await CategoriesQueriesClient.findAll();
                setCategories(res.data.categories);
            } catch (err) {
                console.error("Erreur lors du chargement des catégories:", err);
            }
        };
        fetchCategories();
    }, []);

    return (
        <ProtectedPage key={`shipping-policy-${currentCommand?.id}`} permissionsNeeded="client" needToBeAuthenticated={false} redirectPath="/client-auth">
            <div className="patricians-layout">
                <ClientHeader displayCart={false} currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
                <div className="patricians-main-content">

                    {/* Zone principale avec le contenu */}
                    <div className="policy-container">
                        <div className="policy-content">
                            <div className="policy-header">
                                <h1 className="policy-title">Shipping Policy – Patricians</h1>
                                <p className="policy-subtitle">Information about our shipping and delivery services</p>
                            </div>

                            <div className="policy-section">
                                <h2>Shipping Area</h2>
                                <div className="policy-text">
                                    <p>
                                        Patricians currently ships exclusively within Belgium.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Processing Time</h2>
                                <div className="policy-text">
                                    <p>
                                        All orders are processed within 1–2 business days after payment confirmation. Orders placed on weekends or public holidays will be processed the next business day.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Delivery Time</h2>
                                <div className="policy-text">
                                    <p>
                                        Once shipped, orders are delivered within 1–5 business days, depending on your location in Belgium and the carrier's schedule.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Shipping Carrier & Tracking</h2>
                                <div className="policy-text">
                                    <p>
                                        We work with reliable local shipping partners. As soon as your order is shipped, you will receive an email.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Shipping Costs</h2>
                                <div className="policy-text">
                                    <p>
                                        Shipping costs are calculated at checkout and clearly displayed before payment.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Delays</h2>
                                <div className="policy-text">
                                    <p>
                                        While we aim to meet all delivery times, Patricians is not responsible for delays caused by the shipping carrier, weather conditions, or unforeseen circumstances.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Incorrect Address</h2>
                                <div className="policy-text">
                                    <p>
                                        Please ensure that your shipping details are correct. Patricians cannot be held responsible for orders delivered to an incorrect address provided by the customer.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Questions</h2>
                                <div className="policy-text">
                                    <p>
                                        For any shipping-related questions, feel free to contact us at <a href="mailto:contact@patricians.xyz">contact@patricians.xyz</a>.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-footer">
                                <p className="policy-update">
                                    <strong>Last updated:</strong> {new Date().toLocaleDateString('en-GB')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedPage>
    );
}
